'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const ContentManager = () => {
  const [selectedSection, setSelectedSection] = useState<string>('homepage');

  const sections = [
    { id: 'homepage', label: 'Homepage', icon: 'HomeIcon' },
    { id: 'flights', label: 'Flight Search', icon: 'MagnifyingGlassIcon' },
    { id: 'hotels', label: 'Hotels', icon: 'BuildingOffice2Icon' },
    { id: 'holidays', label: 'Holidays', icon: 'GlobeAltIcon' },
  ];

  const [content, setContent] = useState({
    heroTitle: 'Book Your Perfect Journey',
    heroSubtitle: 'Flights, Hotels & Holiday Packages—all with live pricing',
    heroDescription: 'Compare thousands of options and book with confidence',
  });

  const handleSave = () => {
    alert('Content saved successfully!');
  };

  return (
    <div className="space-y-8">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-heading font-black text-foreground">Content Management</h2>
        <button
          onClick={handleSave}
          className="flex items-center gap-2 px-6 py-3 bg-primary text-white font-bold rounded-lg hover:bg-secondary transition-all duration-200"
        >
          <Icon name="CheckIcon" size={20} />
          <span>Save Changes</span>
        </button>
      </div>

      <div className="grid md:grid-cols-4 gap-6">
        {/* Section Selector */}
        <div className="space-y-2">
          {sections.map((section) => (
            <button
              key={section.id}
              onClick={() => setSelectedSection(section.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg font-bold transition-all duration-200 ${
                selectedSection === section.id
                  ? 'bg-primary text-white' :'bg-surface text-muted-foreground hover:bg-muted'
              }`}
            >
              <Icon name={section.icon as any} size={20} />
              <span>{section.label}</span>
            </button>
          ))}
        </div>

        {/* Content Editor */}
        <div className="md:col-span-3 space-y-6">
          <div className="bg-white rounded-xl p-6 border border-border">
            <h3 className="text-lg font-bold text-foreground mb-4">Homepage Hero Section</h3>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-bold text-foreground mb-2">
                  Hero Title
                </label>
                <input
                  type="text"
                  value={content.heroTitle}
                  onChange={(e) => setContent({ ...content, heroTitle: e.target.value })}
                  className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-bold text-foreground mb-2">
                  Hero Subtitle
                </label>
                <input
                  type="text"
                  value={content.heroSubtitle}
                  onChange={(e) => setContent({ ...content, heroSubtitle: e.target.value })}
                  className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-bold text-foreground mb-2">
                  Hero Description
                </label>
                <textarea
                  value={content.heroDescription}
                  onChange={(e) => setContent({ ...content, heroDescription: e.target.value })}
                  rows={3}
                  className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>
            </div>
          </div>

          {/* Preview */}
          <div className="bg-gradient-to-br from-primary to-secondary rounded-xl p-8 text-white">
            <div className="text-sm font-bold mb-4 opacity-70">PREVIEW</div>
            <h1 className="text-4xl font-heading font-black mb-4">{content.heroTitle}</h1>
            <p className="text-xl mb-2">{content.heroSubtitle}</p>
            <p className="text-white/80">{content.heroDescription}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentManager;